export default __webpack_public_path__ + "static/media/clip-list-is-empty.da9cee4a.png";